import React from "react";
import { useLocation } from "react-router-dom";
import LenderUgroService from "../../services/lender";
import { toast } from "react-toastify";
import './accordionStyle.css'
import { Context } from "../../config/store";

export default function Accordion({
	children,
	label,
	headerId,
	collapseId,
	required = [],
	count,
	isDocumentAccordion = false,
	reloadDocuments,
	cl_lead_lender_status,
	cl_lead_doc_id,
	selectedLender,
	is_all_docs_checked,
	isPostDisbursalCase = false,
	hasExtraFields = false
}) {
	const location = useLocation();
	const [openId, setOpenId] = React.useState('')
	const [isPostDisbursal, setIsPostDisbursal] = React.useState(isPostDisbursalCase)

	const [doc_is_submmiting, setDoc_is_submmiting] = React.useState(false)
	const { state } = React.useContext(Context);

	const handleCheckboxClick = async (e) => {
		setDoc_is_submmiting(true)
		toast.info("Document is submitting. Please wait...")
		let formData = new FormData();

		formData.append('lender_id', selectedLender);
		formData.append('cl_lead_doc_id', cl_lead_doc_id);
		formData.append('is_checked', e ? 1 : 0);

		try {
			const response = await LenderUgroService.shareAllDocumentsAtOnce(formData);
			if (response?.data?.status?.code === 1) {
				setDoc_is_submmiting(false)
				toast.dismiss()
				reloadDocuments()
				toast.success(
					response?.data?.messages?.success?.others[0] ||
					'Documents shared successfully'
				);
			} else {
				setDoc_is_submmiting(false)
				toast.dismiss()
				toast.error(
					response?.message ||
					response?.messages?.error?.form?.[0] ||
					response?.messages?.error?.others?.[0]
				);
			}
		} catch (err) {
			setDoc_is_submmiting(false)
			toast.dismiss()
			toast.error(
				err.response?.data?.message ||
				err.response?.data?.messages?.error?.form[0] ||
				err.response?.data?.messages?.error?.others[0]
			);
		}
	}

	const handleClick = () => {
		setIsPostDisbursal(!isPostDisbursal)
		if ((openId === collapseId) || isPostDisbursal) {
			setOpenId('')
		} else {
			setOpenId(collapseId)
		}
	}
	const checkHasPermission = (checkPermission) => {

		if (state.is_super_admin === 1) return true;
		const permission = state.permission.find(
			(permission) => permission === checkPermission
		);

		if (permission) return true;
		else return false;
	};

	return (
		<div className='card'>
			<div
				className='card-header'
				id={headerId}
			>
				<div className="d-flex">
					{/*{isDocumentAccordion && !location.pathname.includes('post-disbursal') && checkHasPermission('document-submit-to-lender') &&
						<div style={{ width: "2%" }} className={!(hasExtraFields && cl_lead_lender_status && (!isNaN(count) && count > 0) ) && "disabledCheckbox"}>
							{!isNaN(count) &&
								<input
									type="checkbox"
									name="share_doc_to_lender"
									id="share_doc_to_lender"
									checked={is_all_docs_checked === 'Yes' ? true : false}
									onClick={(e) => {
										handleCheckboxClick(e.target.checked)
									}}
									disabled={ (hasExtraFields && cl_lead_lender_status && (!isNaN(count) && count > 0)) && !doc_is_submmiting ? false : true}
								/>
							}
						</div>
					} */}
					<div style={{ width: "100%" }}>
						<h5
							className="d-flex align-items-center justify-content-around mb-0 accordion-heading collapsed"
							data-toggle="collapse"
							aria-expanded={((collapseId === openId) || isPostDisbursal)}
							aria-controls={collapseId}
							onClick={() => {
								handleClick()
							}}
						>
							<span class="flex-1">
								{!isNaN(count) && !location.pathname.includes('post-disbursal') ? (
									<>
										({!isNaN(count) && <span>Docs: {count}</span>})
									</>
								) : (
									''
								)}
								<span className={isDocumentAccordion && "ml-2"}>{label}</span>
								{required?.includes(label) && <span className='text-danger ml-1'>(required)</span>}
							</span>

							<div className='options'>
								<i className='fa fa-chevron-down ml-1'></i>
							</div>
						</h5>
					</div>
				</div>
			</div>
			<div
				id={collapseId}
				className={`collapse ${((collapseId === openId) || isPostDisbursal) && 'show'}`}
				aria-labelledby={headerId}
			>
				<div class="card-body">{children}</div>
			</div>
		</div >
	);
}